import React, { useState } from 'react'
import { HiCheckCircle } from "react-icons/hi"
import { CgClose } from "react-icons/cg"
import StyledButton from '../../layout_components/StyledButton'

const FeaturesTable = () => {

    const [isLoadMore, setisLoadMore] = useState(false)


    const features = [
        {
            content: "See Candidate Reports",
            free: true,
            standard: true,
            premium: true
        },
        {
            content: "Company Branded Game URL",
            free: false,
            standard: true,
            premium: true
        },
        {
            content: "Email Support",
            free: false,
            standard: true,
            premium: true
        },
        {
            content: "Additional Candidate Assessments",
            free: false,
            standard: true,
            premium: true
        },
        {
            content: "Candidate Feedback Survey",
            free: false,
            standard: true,
            premium: true
        },
        {
            content: "Customizable Artwork",
            free: false,
            standard: false,
            premium: true
        },
    ]

    const partialFeatures = features.slice(0, 2)
    const remainingFeatures = features.slice(2, features.length)



    const marks = {
        tick: <HiCheckCircle className=' rounded-3xl text-2xl md:text-lg mx-auto 2xl:text-[1.5rem]' />,
        cross: <CgClose className='rounded-3xl text-2xl md:text-lg mx-auto 2xl:text-[1.5rem]' />
    }

    const toggleLessMore = () => {
        setisLoadMore(!isLoadMore)
    }

    return (
        <>
            <div className='featuresComponent hidden md:block w-[20rem] sm:w-[37rem] lg:w-[80vw] mx-auto 2xl:mt-24'>

                <div className="read-more-less">
                    <div className="flex flex-col border-t-2 border-l-2 border-r-2 rounded-3xl 2xl:w-[90%] 2xl:mx-auto">
                        <div className="overflow-x-auto ">
                            <div className="py-2 inline-block min-w-full">
                                <div className="overflow-hidden">
                                    <table className="min-w-full">
                                        <thead className="border-b">
                                            <tr>
                                                <th scope="col" className="text-sm capitalize font-bold text-[#333333] px-6 py-4 text-left 2xl:text-[26px] 2xl:font-bold 2xl:leading-[36px]">
                                                    Core Features
                                                </th>
                                                <th scope="col" className="text-sm capitalize font-bold text-[#333333] px-6 py-4 text-center 2xl:text-[26px]  2xl:font-bold 2xl:leading-[36px]">
                                                    Free
                                                </th>
                                                <th scope="col" className="text-sm capitalize font-bold text-[#333333] px-6 py-4 text-center 2xl:text-[26px] 2xl:font-bold 2xl:leading-[36px]">
                                                    Standard
                                                </th>
                                                <th scope="col" className="text-sm capitalize font-bold text-[#333333] px-6 py-4 text-center 2xl:text-[26px] 2xl:font-bold 2xl:leading-[36px]">
                                                    Premium
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                partialFeatures.map((feature, index) =>

                                                    <tr key={`trFeature${index}`} className={`${index === 1 ? 'opacity-[0.5]' : null} ${isLoadMore === true ? 'opacity-100' : null} border-b `}>
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 2xl:text-[16px] 2xl:leading-[22px] capitalize">{feature.content}</td>

                                                        <td className="text-sm text-yellow-400  px-6 py-4 whitespace-nowrap">
                                                            {feature.free === true ? marks.tick : marks.cross}
                                                        </td>
                                                        <td className="text-sm text-yellow-400  px-6 py-4 whitespace-nowrap">
                                                            {feature.standard === true ? marks.tick : marks.cross}
                                                        </td>
                                                        <td className="text-sm text-yellow-400  px-6 py-4 whitespace-nowrap">
                                                            {feature.premium === true ? marks.tick : marks.cross}
                                                        </td>

                                                    </tr>
                                                )


                                            }

                                            {
                                                isLoadMore && remainingFeatures.map((feature, index) =>

                                                    <tr key={`trFeature${index}`} className={`${index === 1 ? 'opacity-[0.5]' : null} ${isLoadMore === true ? 'opacity-100' : null} border-b `}>
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 2xl:text-[16px] 2xl:leading-[22px] capitalize">{feature.content}</td>

                                                        <td className="text-sm text-yellow-400  px-6 py-4 whitespace-nowrap">
                                                            {feature.free === true ? marks.tick : marks.cross}
                                                        </td>
                                                        <td className="text-sm text-yellow-400  px-6 py-4 whitespace-nowrap">
                                                            {feature.standard === true ? marks.tick : marks.cross}
                                                        </td>
                                                        <td className="text-sm text-yellow-400  px-6 py-4 whitespace-nowrap">
                                                            {feature.premium === true ? marks.tick : marks.cross}
                                                        </td>

                                                    </tr>
                                                )
                                            }


                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="seeMore flex justify-center mt-8 lg:mt-2">
                        <StyledButton btnEventHandler={toggleLessMore} btnText={isLoadMore === true ? 'Show Less' : 'Show more'} customStyle="!bg-[#FFD700] !text-[#333333] xl:!h-[2.8rem] xl:text-xs xl:font-bold 2xl:!h-[3.5rem] 2xl:font-semibold" />
                    </div>
                </div>
            </div>

            <div className="featuresComponentMobile md:hidden w-[20rem] sm:w-[32rem] mx-auto">
                <h3 className='font-extrabold text-2xl py-4 border-b-2'>Core Features</h3>
                <div className="featuresList">
                    {
                        features.map((feature, index) =>
                            <div key={index} className="featureItem py-5 border-b-2">
                                <p className='text-lg'>{feature.content}</p>
                                <div className="availibility flex justify-between mt-4">
                                    <div className="plan">
                                        <p className='font-bold'>Free</p>
                                        <p className='mt-3 text-yellow-400'>{feature.free === true ? marks.tick : marks.cross}</p>
                                    </div>
                                    <div className="plan">
                                        <p className='font-bold'>Standard</p>
                                        <p className='mt-3 text-yellow-400'>{feature.standard === true ? marks.tick : marks.cross}</p>

                                    </div>
                                    <div className="plan">
                                        <p className='font-bold'>Premium</p>
                                        <p className='mt-3 text-yellow-400'> {feature.premium === true ? marks.tick : marks.cross}</p>
                                    </div>
                                </div>
                            </div>

                        )
                    }
                </div>

            </div>
        </>

    )
}

export default FeaturesTable